import { Segmented } from 'antd';
import styled from 'styled-components';

export const StyledSegmented = styled(Segmented)`
  &.ant-segmented > .ant-segmented-group {
    border: 1px solid ${(props): string => props.theme.colors.grey200};
  }
`;
